import React, { useEffect, useState } from 'react'
import axios from 'axios'
import Pagination from '../pagination/Pagination'
import { Link } from 'react-router-dom'
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';

const Event = () => {


  const userType = sessionStorage.getItem("usertype");
  const userId = sessionStorage.getItem("userId");

  const [Event,setEvent]=useState([])
  const[showPerPage,setShowPerPage]=useState(20)
  const [pagination,setPagination]=useState(
    {
      start:0,
      end:showPerPage
    }
  )
 
  const onChangePagination=(start,end)=>{
    setPagination({start:start,end:end})
  }

const EventsData = async () => {
  const dist = sessionStorage.getItem("dist");
  const res = await axios.post(`https://lionsdirectoryapi.emedha.in/notification/api/event/get`, { dist });
  setEvent(res.data);
};


  useEffect(() => {
    EventsData()
  }, []);





  
const deleteData = (id) => {
  const dist = sessionStorage.getItem("dist");
  if (window.confirm('Are you sure to delete this data...')) {
    axios.post(`https://lionsdirectoryapi.emedha.in/notification/api/event/delete`, {
      id,
      dist
    });
    alert('Data deleted successfully!...');
    setTimeout(() => EventsData(), 100);
  }
};


  return (
   <div>
    <Link to='/add-event'> <button  className='btn btn-warning'>
          Add<PersonAddAltIcon></PersonAddAltIcon>
       </button></Link>
    <div style={{marginTop:'1rem'}} className='table-container'>
        
        <table className="styled-table table table-bordered">
         <thead>
           <tr>
             <th>S.No</th>
             <th>Name</th>
             <th>Event Date</th>
             <th>Venue</th>
             <th>Update</th>
             <th>Delete</th>
           </tr>
           
         </thead>
         <tbody className='table-bordered'>
           {
             Event.slice(pagination.start,pagination.end).map((data,index)=>{
               return(
                 <tr>
                    <td>{pagination.start + index + 1}</td>
                   <td>{data.name}</td>
                   <td>{data.eventdate}</td>
                   <td>{data.venue}</td>
                   <td className=''>
                     <Link  className='btn btn-info' to={`/event-update/${data.sno}`}>update</Link>
                   </td>
                   <td className=''>
                     <Link to='#' className='btn btn-danger' onClick={()=>deleteData(data.sno)}>delete</Link>
                   </td>
                 </tr>
               )
             })
           }
         </tbody>
        </table>
       <Pagination page={showPerPage} onChangePagination={onChangePagination} total={Event.length}/>      
   </div>
   </div>
  )
}

export default Event